<template>
  <div class="-playable-state">
    <div ref="rcp" class="wt-rtp-player">
      <canvas for="player"></canvas>
      <canvas for="movie-processor"></canvas>
      <canvas for="diagnostic"></canvas>
      <div for="buffer-indicator">
        <img
          src="https://dp4stoslb9jdl.cloudfront.net/Resources/studio/img/instant-player/preloader.svg"
        />
      </div>
      <img
        for="pause-indicator"
        alt="Play"
        src="/resources/img/play-icon-02.svg"
      />
      <img
        for="play-indicator"
        alt="Pause"
        src="/resources/img/pause-icon-02.svg"
      />
      <div ref="rcpPanel"></div>
    </div>
  </div>
</template>

<script>
import app from 'app';

export default {
  props: {
    job: { type: Object, required: true },
    story: { type: Object, required: true },
    url: { type: String, default: '' },
    useUrl: { type: Boolean, default: false },
    parts: { type: Object, default: () => ({}) },
    isPlaying: { type: Boolean },
  },

  data() {
    return {
      fpPlayer: null,
      actOnChangeParts: false,
    };
  },

  watch: {
    parts() {
      if (this.actOnChangeParts && this.fpPlayer && this.job) {
        this.fpPlayer.marshalPreviewParts(this.job);
      }
    },
  },

  mounted() {
    this.fpPlayer = new app.namespace.Controller.FullPreviewPlayerController({
      rcpRef: this.$refs.rcp,
      rcpPanelRef: this.$refs.rcpPanel,
      story: this.story,
      onTogglePlay: (isPlaying) => {
        this.$emit('update:isPlaying', isPlaying);
      },
    });

    // can have url and still not ready to useUrl (job not finished with parts)
    if (this.useUrl && this.url) {
      this.fpPlayer.setVideoUrl(this.job);
    } else {
      this.fpPlayer.marshalPreviewParts(this.job);
      this.actOnChangeParts = true;
    }

    this.fpPlayer.play();

    if (!app.rootStore.getters['user/box'].isProd()) {
      window.fpp = this.fpPlayer;
    }

    app.keyboardAccessibility.add(app.KEYBOARD_LAYER.FPV, [
      { on: 'keydown', key: $.ui.keyCode.SPACE, run: this.togglePlay },
      { on: 'keydown', key: $.ui.keyCode.LEFT, run: this.seek },
      { on: 'keydown', key: $.ui.keyCode.RIGHT, run: this.seek },
    ]);
  },

  beforeDestroy() {
    app.keyboardAccessibility.remove(app.KEYBOARD_LAYER.FPV);

    if (this.fpPlayer) {
      this.fpPlayer.destroy();
    }
  },

  methods: {
    togglePlay: function (e) {
      if (!this.$isEditable(e.target)) {
        e.preventDefault();
        this.fpPlayer.togglePlay();
      }
    },

    pausePlay: function () {
      this.fpPlayer.pause();
    },

    seek: function (e) {
      if (!this.$isEditable(e.target)) {
        e.preventDefault();
        this.fpPlayer.seek(e.which === $.ui.keyCode.LEFT ? -1 : 1);
      }
    },

    takeScreenshot: function () {
      this.fpPlayer.pause();
      return this.fpPlayer.takeScreenshot();
    },
  },
};
</script>
